import { render } from "./PedidoMinimoPage.vue?vue&type=template&id=63a07591&scoped=true"
import script from "./PedidoMinimoPage.vue?vue&type=script&lang=js"
export * from "./PedidoMinimoPage.vue?vue&type=script&lang=js"

import "./PedidoMinimoPage.vue?vue&type=style&index=0&id=63a07591&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a07591"]])

export default __exports__